(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > 50) {
        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop) {
        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= 50) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.style.transform = 'translateY(-100%)';
      this.header.style.transition = 'transform 0.3s ease';
    }

    reveal() {
      this.header.style.transform = 'translateY(0)';
      this.header.style.transition = 'transform 0.3s ease';
      this.header.classList.add('shopify-section-header-sticky');
    }

    reset() {
      this.header.style.transform = 'translateY(0)';
      this.header.classList.remove('shopify-section-header-sticky');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
